import React, { useReducer } from "react";
import axios from "axios";
import { isActiveToken, getToken } from "./../../common/functions";
import Login from "./../Login/Login";
import Registration from "../Registration/registration";
import PasswordReset from "../PasswordReset/PasswordReset";

import { AuthReducer } from "./AuthReducer";

const ButtonToLogin = ({ fn }) => (
  <div className="text-white">
    <i className="fas fa-backspace"></i>{" "}
    <a
      href="#"
      className="text-white"
      onClick={() => fn({ type: "SHOW_LOGIN" })}
    >
      <small>Volver a iniciar sesión.</small>
    </a>
  </div>
);

const ButtonToRegistration = ({ fn }) => (
  <button
    className="btn btn-lg btn-block btn-dark mt-4 mb-2"
    onClick={() => fn({ type: "SHOW_REGISTRATION" })}
  >
    Crear cuenta
  </button>
);

const ButtonToPasswordReset = ({ fn }) => (
  <p className="text-right mt-2">
    <a
      href="#"
      className="text-white"
      onClick={() => fn({ type: "SHOW_PASSWORD_RESET" })}
    >
      <small>¿Olvidaste tu contraseña?</small>
    </a>
  </p>
);

const Auth = ({
  withoutCookies = false,
  isPasswordReset = false,
  children,
}) => {
  let initialState = {
    isLogin: true,
    isRegistration: false,
    isPasswordReset: false,
  };

  if (isPasswordReset) {
    initialState = { ...initialState, isLogin: false, isPasswordReset };
  }
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  /** Add a request interceptor - Do something before request is sent */
  // if (isActiveToken("token") && !withoutCookies) { <- LOCALHOST MODE
  if (isActiveToken("token") && isActiveToken("csrftoken") && !withoutCookies) {
    axios.interceptors.request.use((config) => {
      config.headers.Authorization = `Token ${getToken()}`;
      config.headers["Content-Type"] = "application/json";
      return config;
    });

    return children;
  }

  return (
    <div className="container-md">
      <div className="row">
        <div className="col-2" />
        <div className="col-8">
          {state.isLogin && (
            <>
              <Login
                btnPasswordReset={<ButtonToPasswordReset fn={dispatch} />}
              />
              <p>
                <ButtonToRegistration fn={dispatch} />
              </p>
            </>
          )}

          {state.isRegistration && (
            <>
              <Registration />
              <ButtonToLogin fn={dispatch} />
            </>
          )}

          {state.isPasswordReset && (
            <>
              <PasswordReset isResetConfirmation={isPasswordReset} />
              <ButtonToLogin fn={dispatch} />
            </>
          )}
        </div>
        <div className="col-2" />
      </div>
    </div>
  );
};

export default Auth;
